import styled from "styled-components";
import { bp } from "theme";

export const MobileContainer = styled.div`
	${bp.md} {
		display: none;
	}
`;

export const DesktopContainer = styled.div`
	display: none;
	${bp.md} {
		display: block;
	}
`;

export const TopCompanyBannerContainer = styled.a`
	display: block;
	position: relative;
	height: 240px;
`;
